"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CopyPartResult = {
    type: "structure",
    required: [],
    members: {
        ETag: {
            shape: {
                type: "string"
            }
        },
        LastModified: {
            shape: {
                type: "timestamp"
            }
        }
    }
};
//# sourceMappingURL=_CopyPartResult.js.map